/**
 * Mind you, this gets translated in media.js.breakpoints
 * to max-width, mobile first, media queries.
 */
const sizes: any = {
    xxxl: 2561,
    xxl: 1920,
    xl: 1366,
    lg: 1280,
    md: 1025,
    tb: 897,
    sm: 720,
    xs: 320,
};

export default sizes;
